export namespace LocalStorageHelper {
    export const communityIdKey = "communityId";

    export function normalize(value: string | null | undefined): string | null {
        return value && value !== "null" && value.trim() !== "" ? value : null;
    }

    export function getItem(key: string): string | null {
        if (typeof window === "undefined") {
            return null;
        }

        try {
            return normalize(localStorage.getItem(key));
        } catch {
            return null;
        }
    }

    export function setItem(key: string, value: string | null | undefined): void {
        if (typeof window === "undefined") {
            return;
        }

        try {
            const normalizedValue = normalize(value);
            if (normalizedValue) {
                localStorage.setItem(key, normalizedValue);
            } else {
                localStorage.removeItem(key);
            }
        } catch {
        }
    }

    export function removeItem(key: string): void {
        if (typeof window === "undefined") {
            return;
        }

        try {
            localStorage.removeItem(key);
        } catch {
        }
    }

    export function getCommunityId(): string | null {
        return getItem(communityIdKey);
    }

    export function setCommunityId(communityId: string | null | undefined): void {
        setItem(communityIdKey, communityId);
    }

    export function removeCommunityId(): void {
        removeItem(communityIdKey);
    }
}
